import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency } from '../contexts/AuthContext';
import { Plus, Lock, Search } from 'lucide-react';

export default function Usuarios() {
  const { token, user } = useAuth();
  const [users, setUsers] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'employee' });
  const [changeOpen, setChangeOpen] = useState(false);
  const [cpwd, setCPwd] = useState({ currentPassword: '', newPassword: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/users`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setUsers(d)).catch(() => {});
  }, [token]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/users/`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(form) });
      if (!r.ok) { setMsg('Erro ao criar usuário'); return; }
      setMsg('Usuário criado'), setOpen(false);
      fetch(`${API_URL}/users`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setUsers(d)).catch(() => {});
    } catch { setMsg('Erro interno'); }
  };

  const changePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/auth/change-password`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(cpwd) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); setMsg(j.error || 'Erro'); return; }
      setMsg('Senha alterada com sucesso'), setChangeOpen(false);
    } catch { setMsg('Erro interno'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Usuários</h1>
          <p className="text-gray-600">Gerenciamento de funcionários e permissões</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary"><Plus size={18} /> Novo usuário</button>
      </div>
      {msg && <div className="rounded-lg p-3 text-sm bg-green-50 border border-green-200 text-green-700">{msg}</div>}
      <div className="card">
        <h2 className="text-sm font-semibold text-gray-700 mb-3">Alterar minha senha</h2>
        <form onSubmit={changePassword} className="space-y-3">
          <div><label className="text-xs font-medium text-gray-500 block mb-1">Senha atual</label><input className="input" type="password" value={cpwd.currentPassword} onChange={e => setCPwd({ ...cpwd, currentPassword: e.target.value })} required /></div>
          <div><label className="text-xs font-medium text-gray-500 block mb-1">Nova senha (mín. 6)</label><input className="input" type="password" value={cpwd.newPassword} onChange={e => setCPwd({ ...cpwd, newPassword: e.target.value })} required /></div>
          <button className="btn-primary w-full">Alterar senha</button>
        </form>
      </div>
      <div className="table-wrap">
        <table className="w-full text-left text-sm">
          <thead><tr className="border-b border-gray-200"><th className="pb-2 text-gray-500">Nome</th><th className="pb-2 text-gray-500">E-mail</th><th className="pb-2 text-gray-500">Perfil</th><th className="pb-2 text-gray-500">Status</th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} className="border-b border-gray-100 last:border-0">
                <td className="py-2 font-medium">{u.name}</td>
                <td className="py-2">{u.email}</td>
                <td className="py-2"><span className={`badge ${u.role === 'admin' ? 'badge-warn' : 'badge-ok'}`}>{u.role}</span></td>
                <td className="py-2"><span className={`badge ${u.is_active ? 'badge-ok' : 'badge-danger'}`}>{u.is_active ? 'Ativo' : 'Inativo'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && <div className="text-center text-gray-500 text-sm py-8">Nenhum usuário</div>}
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Novo usuário</h2>
            <form onSubmit={save} className="space-y-3">
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Nome</label><input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">E-mail</label><input className="input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Senha (mín. 6)</label><input className="input" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Perfil</label><select className="input" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}><option value="admin">Administrador</option><option value="employee">Funcionário</option></select></div>
              <div className="flex justify-end gap-2 pt-4">
                <button type="button" onClick={() => setOpen(false)} className="btn-ghost px-4">Cancelar</button>
                <button className="btn-primary">Criar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
